import { Outlet } from 'react-router-dom';
import { GiftContextProvider } from './Context/GiftContextProvider';

const GiftLayout = () => {
  return (
    <GiftContextProvider>
      <Outlet />
    </GiftContextProvider>
  );
};

export default GiftLayout;
